/**
 * Takes an ABSOLUTE URL and returns a new URL string
 * with 'contentDisposition=attachment'.
 */
export const formatUrlForDownload = (url: string): string | undefined => {
    try {
        const urlToDownload = new URL(url);

        urlToDownload.searchParams.set('contentDisposition', 'attachment');

        return urlToDownload.href;
    } catch (error) {
        return undefined;
    }
};
